/**
 * HTML escape & filename sanitization utilities
 */

export function esc(str: string): string {
  if (!str) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/** Alias for esc() — used in some legacy code as escapeHtml */
export const escapeHtml = esc;

export function sanitizeFilename(name: string): string {
  return (
    name
      .toLowerCase()
      .replace(/[äàâ]/g, 'a')
      .replace(/[öòô]/g, 'o')
      .replace(/[üùû]/g, 'u')
      .replace(/[éèê]/g, 'e')
      .replace(/[ß]/g, 'ss')
      .replace(/[^a-z0-9]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .substring(0, 50) || 'website'
  );
}
